import styled from 'styled-components';
import { baseVariables, toRem } from '@marriott/mi-ui-library';
import { mediaQuery } from '../../../../utils/styles';

export const MutliPropertyContainer = styled.div`
  max-width: 100vw;
  background-color: ${baseVariables.color.neutral10};
  .mpo-wrapper {
    padding: ${toRem(60)} ${toRem(16)};
    display: flex;
    justify-content: space-between;
    @media ${mediaQuery.tabletOnly} {
      padding: ${toRem(60)} ${toRem(8)};
    }
    @media ${mediaQuery.mobileOnly} {
      flex-direction: column;
      gap: ${toRem(16)};
      padding: ${toRem(88)} 1rem ${toRem(40)} 1rem;
    }
  }
`;

export const LeftDetails = styled.div`
  width: 45%;
  margin-right: 5%;
  @media ${mediaQuery.mobileOnly} {
    width: 100%;
  }
  .heading {
    width: ${toRem(300)};
    height: ${toRem(32)};
    margin-bottom: ${toRem(10)};
    @media ${mediaQuery.mobileOnly} {
      width: ${toRem(200)};
      height: ${toRem(28)};
    }
  }
  .description-container {
    margin-top: ${toRem(10)};
    margin-bottom: ${toRem(16)};
  }
  .sub-heading {
    margin-bottom: ${toRem(10)};
    width: ${toRem(150)};
    height: ${toRem(24)};
  }
  .offer-description {
    width: 100%;
    height: ${toRem(16)};
    margin-bottom: ${toRem(5)};
  }
  .terms-and-conditions {
    width: ${toRem(200)};
    height: ${toRem(16)};
    margin-top: ${toRem(16)};
  }
`;
export const RightDetails = styled.div`
  width: 45%;
  @media ${mediaQuery.mobileOnly} {
    width: 100%;
  }
  .sub-heading {
    width: ${toRem(300)};
    height: ${toRem(16)};
    margin-bottom: ${toRem(5)};
    @media ${mediaQuery.mobileOnly} {
      width: ${toRem(300)};
    }
  }
  .offer-description {
    width: 100%;
    height: ${toRem(28)};
    margin: ${toRem(15)} ${toRem(0)};
  }
`;
